import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/styles';
import styles from './styles';

export default withStyles(styles)(List);
